export default function (ctx) {
  console.log("AUTH MIDDLEWARE:", {
    loggedIn: ctx.$auth.loggedIn,
    path: ctx.route.path,
  })

  if (!ctx.$auth.loggedIn && ctx.route.path !== '/login') {
    return ctx.redirect('/login')
  }
}
